import styles from "./styles.module.css";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import darkLogo from "../../../../logo-contact-white.svg";

const LIGHT_LOGO_SRC =
  "https://epinics.com/static/media/logo-contact.7e2887bc289aad2327275ee13a3a4a50.svg";

const Logo = ({ themeMode }) => {
  const logoSrc = themeMode === "dark" ? darkLogo : LIGHT_LOGO_SRC;
  return (
    <div className={styles.logoAndName}>
      <img key={themeMode} src={logoSrc} alt="Logo" className={styles.logoImg} />
      <h2 className={styles.logoText}>EPINICS</h2>
    </div>
  );
};

Logo.propTypes = {
  themeMode: PropTypes.oneOf(["light", "dark"]),
};

const mapStateToProps = (state) => ({
  themeMode: state.theme?.mode ?? "light",
});

export default connect(mapStateToProps)(Logo);
